export default class Chokes {
    constructor(track) {
        this.track = track;

        // choke can be set to track that it should choke when this track
        // is triggered
        this.choke = undefined;

        // transpose can be set to track that it's transpose should
        // matched to when triggered (for example, match a kick's
        // transpose to the transpose of an 808 sub)
        this.transposeMatch = undefined;

        // if chokingDuration > 0 then this track should not trigger
        this.chokingDuration = 0;

        this.isLiveTriggering = false;
    }

    onStep() {
        this.chokingDuration = Math.max(this.chokingDuration - 1, 0);
    }

    newChoke(duration, time) {
        this.chokingDuration = duration;
        this.track.releaseAll(time);
    }

    isChoked() {
        return this.isLiveTriggering || this.chokingDuration > 0;
    }

    liveTrigger() {
        if (this.choke) {
            this.choke.chokes.isLiveTriggering = true;
            this.choke.releaseAll();
        }
    }

    liveRelease() {
        if (this.choke) {
            this.choke.chokes.isLiveTriggering = false;
        }
    }

    getJson() {
        return {
            choke: this.choke === undefined ?
                undefined :
                this.choke.trackNumber,
        };
    }

    fromJson(json, tracks) {
        if (json.choke !== undefined) {
            this.choke = tracks[json.choke];
        }
    }
}

